<div class="playboard-panel">
  <mat-expansion-panel class="play-panel" [expanded]="uiService.isRightPlaylistPanelExpanded"
    (opened)="uiService.isRightPlaylistPanelExpanded = true" (closed)="uiService.isRightPlaylistPanelExpanded = false">
    <mat-expansion-panel-header [collapsedHeight]="headerHeight" [expandedHeight]="headerHeight">
      <mat-panel-title class="uppercase">
        <span class="w-100" matTooltip="Play/Stop playlist on multiple screens">Play next</span>

        <ng-container *ngIf="selectedScreens.length && uiService.isRightPlaylistPanelExpanded">
          <div (click)="$event.stopPropagation();">
            <button *ngIf="showPlay && !showPendingSpinner" mat-icon-button class="all-button play" [disableRipple]="true" (click)="playAll()">
              <mat-icon class="middle-icon" svgIcon="play_arrow" matTooltip="Play all">
              </mat-icon>
            </button>

            <button *ngIf="showStop && !showPendingSpinner" mat-icon-button class="all-button stop" [disableRipple]="true" (click)="stopAll()">
              <mat-icon svgIcon="stop" matTooltip="Stop all"></mat-icon>
            </button>

            <mat-spinner *ngIf="showPendingSpinner" [diameter]="36"></mat-spinner>
          </div>
        </ng-container>

      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-container *ngIf="selectedScreens.length; else noScreenSelected">
      <div id="playpanelcontent" class="play-panel-content">
        <screen-assign *ngFor="let monitor of selectedScreens" [screen]="monitor"></screen-assign>
      </div>
    </ng-container>

    <ng-template #noScreenSelected>
      <div class="h-100 w-100 d-flex justify-content-center align-items-center px-4 info-block">
        <span class="text-center info-text">Select screens to see their playlist`s actions</span>
      </div>
    </ng-template>

  </mat-expansion-panel>

  <mat-expansion-panel class="schedule-panel" [expanded]="uiService.isSchedulePanelExpanded"
    (opened)="onSchedulePanelOpened()" (closed)="uiService.isSchedulePanelExpanded = false">
    <mat-expansion-panel-header [collapsedHeight]="headerHeight" [expandedHeight]="headerHeight">
      <mat-panel-title class="uppercase" matTooltip="List with the schedules for selected screens">
        Schedule
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-button-toggle-group [(ngModel)]="scheduleCalendarMode" #group="matButtonToggleGroup" class="buttons-group"
      (change)="onModeChange()">
      <mat-button-toggle [value]="scheduleCalendarModes.Day" matTooltip="Day">
        Day
      </mat-button-toggle>
      <mat-button-toggle [value]="scheduleCalendarModes.Week" matTooltip="Week">
        Week
      </mat-button-toggle>
      <mat-button-toggle [value]="scheduleCalendarModes.Month" matTooltip="Month">
        Month
      </mat-button-toggle>
    </mat-button-toggle-group>

    <div class="schedules-content" *ngIf="scheduleItems; else noMonitorSelected">
      <div *ngFor="let item of scheduleItems.ScheduleRequestItems">
        <div class="schedule-title">{{item.Date|date}}</div>
        <screen-schedule *ngFor="let monSch of item.MonitorSchedulesItems" [screen]="monSch.Monitor"
          [schedules]="monSch.ScheduleItems"></screen-schedule>
      </div>
    </div>

    <ng-template #noMonitorSelected>
      <div class="h-100 d-flex justify-content-center align-items-center px-4">
        <span class="text-center info-text">Select screens to see their scheduled playlists</span>
      </div>
    </ng-template>

  </mat-expansion-panel>
</div>
